export default {
  data() {
    return {
      rules: {
        firstName: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => /^[ '-.A-Za-zÀ-ÖØ-öø-ž]+$/.test(v) || 'Ce champ contient des caractères invalides',
          (v) => !(/^[ '-.]+$/.test(v)) || 'Ce champ est invalide',
        ],
        lastName: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => /^[ '-.A-Za-zÀ-ÖØ-öø-ž]+$/.test(v) || 'Ce champ contient des caractères invalides',
          (v) => !(/^[ '-.]+$/.test(v)) || 'Ce champ est invalide',
        ],
        email: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => /.+@.+\..+/.test(v) || 'L\'adresse e-mail doit être valide',
          (v) => !v.includes('@condorcet.be') || 'Utilisez une adresse privée, pas votre identifiant Condorcet',
        ],
        password: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => !(/^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*)$/.test(v))
          || 'Minimum 8 caractères dont majuscule, minuscule et chiffre',
        ],
        confirmPassword: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => v === this.password || 'La confirmation doit correspondre au mot de passe',
        ],
        birthDate: [(v) => !!v || 'Ce champ est obligatoire'],
        nationality: [(v) => !!v || 'Ce champ est obligatoire'],
        mobile: [
          (v) => !!v || 'Ce champ est obligatoire',
          (v) => /^(\+)?([ 0-9]){10,16}$/.test(v) || 'Ce champ est invalide (ex: +32472123456)',
        ],
        streetAndNumber: [(v) => !!v || 'Ce champ est obligatoire'],
        zipCode: [(v) => !!v || 'Ce champ est obligatoire'],
        city: [(v) => !!v || 'Ce champ est obligatoire'],
        country: [(v) => !!v || 'Ce champ est obligatoire'],
      },
    };
  },
};
